import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';

interface BackDeliveryReceiptBatchState extends ListState<any> {
}

class BackDeliveryReceiptBatchMutations extends ListMutations<any>{

}
class BackDeliveryReceiptBatch extends ListModule<BackDeliveryReceiptBatchState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<BackDeliveryReceiptBatchState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/DeliveryReceipt/GetBatchList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: BackDeliveryReceiptBatchState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackDeliveryReceiptBatchState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backDeliveryReceiptBatch = new BackDeliveryReceiptBatch();
export default backDeliveryReceiptBatch;